/* eslint-disable class-methods-use-this */

/* eslint-disable max-classes-per-file */
import { AxiosRequestConfig, AxiosResponse } from 'axios';
import { http } from 'SharedDir/backend/axios/http';
import { Omit } from 'handsontable/settings';

import AccountApiClass from 'SharedDir/backend/api/classes/AccountApiClass';
import ActualizationConfigApiClass from 'SharedDir/backend/api/classes/ActualizationConfigApiClass';
import AdministrationNewsApiClass from 'SharedDir/backend/api/classes/AdministrationNewsClass';
import AdministrationServiceApiClass from 'SharedDir/backend/api/classes/AdministrationServiceApiClass';
import AttachmentsApiClass from 'SharedDir/backend/api/classes/AttachmentsApiClass';
import BanksApiClass from 'SharedDir/backend/api/classes/BanksApiClass';
import CatalogsApiClass from 'SharedDir/backend/api/classes/CatalogsApiClass';
import CertificatesApiClass from 'SharedDir/backend/api/classes/CertificatesApiClass';
import { ChatsApiClass } from 'SharedDir/backend/api/classes/ChatsApiClass';
import CommissionApplicationsApiClass from 'SharedDir/backend/api/classes/CommissionApplicationsApiClass';
import CommissionMeetingsApiClass from 'SharedDir/backend/api/classes/CommissionMeetingsApiClass';
import CommissionDecisionsApiClass from 'SharedDir/backend/api/classes/CommissionDecisionsApiClass';
import CommissionParagraphsApiClass from 'SharedDir/backend/api/classes/CommissionParagraphsApiClass';
import DecreeGsmApiClass from 'SharedDir/backend/api/classes/DecreeGsmApiClass';
import DepartmentApiClass from 'SharedDir/backend/api/classes/DepartmentApiClass';
import DepzdravExportApiClass from 'SharedDir/backend/api/classes/DepzdravExportAPi';
import EpguErrorApiClass from 'SharedDir/backend/api/classes/EpguErrorApiClass';
import FieldsApiClass from 'SharedDir/backend/api/classes/FieldsApiClass';
import FoldersApiClass from 'SharedDir/backend/api/classes/FoldersApiClass';
import IntegrationHistoryApiClass from 'SharedDir/backend/api/classes/IntegrationHistoryApiClass';
import IntegrationPersonApiClass from 'SharedDir/backend/api/classes/IntegrationPersonApiClass';
import IntegrationPersonConfigApiClass from 'SharedDir/backend/api/classes/IntegrationPersonConfigApiClass';
import IssueReportTemplatesApiClass from 'SharedDir/backend/api/classes/IssueReportTemplatesApiClass';
import IssuesApiClass from 'SharedDir/backend/api/classes/IssuesApiClass';
import MassMediaApiClass from 'SharedDir/backend/api/classes/MassMediaApiClass';
import { MassNotificationApiClass } from 'SharedDir/backend/api/classes/MassNotificationApiClass';
import { MtsTypeApiClass } from 'SharedDir/backend/api/classes/NomenclatureCatalogClasses/MtsTypeApiClass';
import NotificationApiClass from 'SharedDir/backend/api/classes/NotificationApiClass';
import OrganizationTtpExcerptApiClass from 'SharedDir/backend/api/classes/OrganizationTtpExcerptApiClass';
import PersonDeerApiClass from 'SharedDir/backend/api/classes/PersonDeerApiClass';
import PersonTtpExcerptApiClass from 'SharedDir/backend/api/classes/PersonTtpExcerptApiClass';
import { PhysicalPersonApiClass } from 'SharedDir/backend/api/classes/PhysicalPersonApiClass';
import ProfileTypeApiClass from 'SharedDir/backend/api/classes/ProfileTypeApiClass';
import ProjectApiClass from 'SharedDir/backend/api/classes/ProjectApiClass';
import ProjectDescriptionApiClass from 'SharedDir/backend/api/classes/ProjectDescriptionApiClass';
import PublicNewsApiClass from 'SharedDir/backend/api/classes/PublicNewsApiClass';
import PublicServicesApiClass from 'SharedDir/backend/api/classes/PublicServiceApiClass';
import PublicUsefulLinksApiClass from 'SharedDir/backend/api/classes/PublicUsefulLinksApiClass';
import ReportsKindApiClass from 'SharedDir/backend/api/classes/ReportsKindApiClass';
import SchedulingTasksApiClass from 'SharedDir/backend/api/classes/SchedulingTasksApiClass';
import SedDeloApiClass from 'SharedDir/backend/api/classes/SedDeloApiClass';
import StatisticsPublicApiClass from 'SharedDir/backend/api/classes/StatisticsPublicApiClass';
import TagsApiClass from 'SharedDir/backend/api/classes/TagsApiClass';
import TemplatesApiClass from 'SharedDir/backend/api/classes/TemplatesApiClass';
import GlobalSettingsApiClass from 'SharedDir/backend/api/classes/GlobalSettingsApiClass';
import TmcRegistryApiClass from 'SharedDir/backend/api/classes/TmcRegistryApiClass';
import TmcRegistryNpaApiClass from 'SharedDir/backend/api/classes/TmcRegistryNpaApiClass';
import TtpEventHistoryClass from 'SharedDir/backend/api/classes/TtpEventHistoryClass';
import UsefulLinksApiClass from 'SharedDir/backend/api/classes/UsefulLinksApiClass';
import UserApiClass from 'SharedDir/backend/api/classes/UserApiClass';
import UserHistoryApiClass from 'SharedDir/backend/api/classes/UserHistoryApiClass';
import UserProfileApiClass from 'SharedDir/backend/api/classes/UserProfileApiClass';
import SimpleApi from 'SharedDir/backend/api/classes/simpleApi';
import { activityUrl } from 'SharedDir/backend/endpoints/activity';
import { roleUrl } from 'SharedDir/backend/endpoints/administration-role';
import { ADMINISTRATION_USER } from 'SharedDir/backend/endpoints/administration-user';
import { deerMeatSaleUrl } from 'SharedDir/backend/endpoints/deer-meat-sale';
import { DOCUMENTS_URL } from 'SharedDir/backend/endpoints/documents';
import { individualDeersUrl } from 'SharedDir/backend/endpoints/individual-deers';
import { materialResourceUrl } from 'SharedDir/backend/endpoints/material-resource';
import { measureUrl } from 'SharedDir/backend/endpoints/measure';
import { messageTemplateUrl } from 'SharedDir/backend/endpoints/message-template';
import {
  licenseAreUrl,
  nationUrl,
  subsurfaceUserUrl,
  thdBuildingUrl,
} from 'SharedDir/backend/endpoints/nomenclature-catalogs';
import { NSUD_REGISTRY_URL } from 'SharedDir/backend/endpoints/nsud-reestr';
import { BASE_ORGANIZATION_URL } from 'SharedDir/backend/endpoints/organizations';
import {
  TTP_PERSON_API,
  householdRolesUrl,
  householdsUrl,
} from 'SharedDir/backend/endpoints/physical-person';
import {
  cashPaymentsUrl,
  EGISSO_REQUESTS,
  egissoRequestsUrl,
  egissoUrl,
} from 'SharedDir/backend/endpoints/registry-material-resource';
import {
  reportsUrlDesorganized,
  reportsUrlGasu,
  reportsUrlGrants,
} from 'SharedDir/backend/endpoints/reports-kind';
import { smsIntegrationUrl } from 'SharedDir/backend/endpoints/sms-integration';
import { Nation, NationCreate } from 'SharedDir/declarations/NomenclatureCatalogs/nation';
import {
  LicenseArea,
  SubsurfaceUser,
} from 'SharedDir/declarations/NomenclatureCatalogs/subsurface-user';
import { CashPaymentBare, CashPaymentUpdate } from 'SharedDir/declarations/cash-payments';
import { Catalogs } from 'SharedDir/declarations/catalogs';
import { DeerMeatSale } from 'SharedDir/declarations/deer-meat-sale';
import {
  DocumentBare,
  DocumentCreate,
  DocumentFull,
  DocumentUpdate,
} from 'SharedDir/declarations/documents';
import { Egisso } from 'SharedDir/declarations/egisso';
import { StatusResponse } from 'SharedDir/declarations/endpoint';
import { IndividualDeers } from 'SharedDir/declarations/individual-deers';
import { MaterialResource } from 'SharedDir/declarations/material-resource';
import { MeasureUnitBare, MeasureUnitCreate } from 'SharedDir/declarations/measure';
import { MessageTemplate } from 'SharedDir/declarations/message-template';
import { NsudReestKmnsActualizationHistoryBare } from 'SharedDir/declarations/nsud-reestr';
import {
  Organization,
  OrganizationBare,
  OrganizationCreate,
} from 'SharedDir/declarations/organization';
import {
  ChangeHouseholdDelegate,
  HouseholdBuilding,
  HouseholdShort,
  PersonFull,
} from 'SharedDir/declarations/physical-person';
import { RegistryMaterialResource } from 'SharedDir/declarations/registry-material-resource';
import { PermissionTranslated, Role } from 'SharedDir/declarations/role';
import { New } from 'SharedDir/declarations/shared';
import { SmsIntegrations } from 'SharedDir/declarations/sms-integrations';
import { TTPRegistries } from 'SharedDir/declarations/ttp-registries';

import { economicalRelationshipsUrl, identityDocumentsUrl } from '../endpoints/ttp-registries';

import AdministrationIntegrationApiClass from './classes/AdministrationIntegrationApiClass';
import AdministrationServiceRouteApiClass from './classes/AdministrationServiceRouteApiClass';
import { CommuneApiClass } from './classes/CommuneApiClass';
import FeedbackApiClass from './classes/FeedbackApiClass';
import { FounderPersonApiClass } from './classes/FounderPersonApiClass';
import GeneralizedHistoryApiClass from './classes/GeneralizedHistoryApiClass';
import NotificationHistoryApiClass from './classes/NotificationHistoryApiClass';
import ServiceGroupsApiClass from './classes/ServiceGroupsApiClass';
import StatisticsApiClass from './classes/StatisticsApiClass';
import TimetableExceptionsApiClass from './classes/TimetableExceptionsApiClass';
import TtpApiClass from './classes/TtpApiClass';
import TtpHistoryApiClass from './classes/TtpHistoryApiClass';
import TtpOrganizationsApiClass from './classes/TtpOrganizationsApiClass';
import ServiceLLMApiClass from './classes/ServiceLLMApiClass';

interface CatalogIn {
  name: string;
  shortName: string;
  typeId: number | null;
}

type CatalogUpdate = Omit<CatalogIn, 'typeId'>;

interface Catalog extends CatalogIn {
  id: number;
  createdAtr: string;
}

interface CatalogFull extends Catalog {
  type: any;
}

export const CatalogsApi = new CatalogsApiClass();

export const UserCertificatesApi = new CertificatesApiClass();

export const UserApi = new UserApiClass();

export const BanksApi = new BanksApiClass();

export const EpguErrorApi = new EpguErrorApiClass();

export const NsudRegistryApi = new SimpleApi<
  NsudReestKmnsActualizationHistoryBare,
  NsudReestKmnsActualizationHistoryBare
>(NSUD_REGISTRY_URL);

export const SchedulingTasksApi = new SchedulingTasksApiClass();

export const TtpHistoryApi = new TtpHistoryApiClass();

export const UserRecipientsApi = new (class extends UserApiClass {
  protected getPaginationEndpoint(): AxiosRequestConfig {
    return { url: ADMINISTRATION_USER.RECIPIENTS.url, method: 'get' };
  }

  protected getExportEndpoint(): AxiosRequestConfig {
    return { url: `${ADMINISTRATION_USER.RECIPIENTS.url}/export`, method: 'post' };
  }
})();

export const ProjectDescriptionApi = new ProjectDescriptionApiClass();

export const CashPaymentsApi = new SimpleApi<
  CashPaymentBare,
  never,
  CashPaymentUpdate,
  CashPaymentBare
>(cashPaymentsUrl);

export const DepartmentApi = new DepartmentApiClass();

export const PublicUsefulLinksApi = new PublicUsefulLinksApiClass();

export const RoleApi = new (class extends SimpleApi<Role, Role> {
  async getAllPermissions() {
    const { data } = (await http({
      method: 'get',
      url: `${this.url}/permissions`,
    })) as AxiosResponse<Required<PermissionTranslated>[]>;
    return data;
  }
})(roleUrl);

export const UserHistoryApi = new UserHistoryApiClass();

export const OrganizationApi = new SimpleApi<
  Organization,
  OrganizationCreate,
  OrganizationBare,
  OrganizationBare
>(BASE_ORGANIZATION_URL);

export const MaterialResourceApi = new SimpleApi<
  MaterialResource.MaterialResourceBare,
  MaterialResource.MaterialResourceCreate
>(materialResourceUrl);

export const UserProfileApi = new UserProfileApiClass();

export const ProfileTypeApi = new ProfileTypeApiClass();

/**
 * Апи класс для взаимодействия с полями по рест.
 * @type {FieldsApiClass}
 */
export const FieldsApi = new FieldsApiClass();

/**
 * Администрирование мер поддержки и услуг
 */
export const AdministrationServiceApi = new AdministrationServiceApiClass();

export const MassNotificationApi = new MassNotificationApiClass();

export const AdministrationServiceRouteApi = new AdministrationServiceRouteApiClass();

export const AdministrationIntegrationApi = new AdministrationIntegrationApiClass();

export const IntegrationPersonConfigApi = new IntegrationPersonConfigApiClass();

export const ActualizationConfigApi = new ActualizationConfigApiClass();

export const IntegrationHistoryApi = new IntegrationHistoryApiClass();

/**
 * Загрузка, удаление, скачивание и все что связано с файлами
 * @type {AttachmentsApiClass}
 */
export const AttachmentsApi = new AttachmentsApiClass();

export const TemplatesApi = new TemplatesApiClass();

export const ServiceGroupsApi = new ServiceGroupsApiClass();

export const NotificationHistoryApi = new NotificationHistoryApiClass();

export const GeneralizedHistoryApi = new GeneralizedHistoryApiClass();

export const ReportsApi = new ReportsKindApiClass();
export const ReportsGasuApi = new (class extends ReportsKindApiClass {
  protected readonly url = `${reportsUrlGasu}`;
})();
export const ReportsGrantsApi = new (class extends ReportsKindApiClass {
  protected readonly url = `${reportsUrlGrants}`;
})();
export const ReportsDesorganizedApi = new (class extends ReportsKindApiClass {
  protected readonly url = `${reportsUrlDesorganized}`;
})();

export const TagsApi = new TagsApiClass();

export const GlobalSettingsApi = new GlobalSettingsApiClass();

export const TmcRegistryApi = new TmcRegistryApiClass();

export const TmcRegistryNpaApi = new TmcRegistryNpaApiClass();

export const DecreeGsmApi = new DecreeGsmApiClass();

export const IssueApi = new IssuesApiClass();

export const IssueReportTemplatesApi = new IssueReportTemplatesApiClass();

export const PublicServiceApi = new PublicServicesApiClass();

export const ProjectApi = new ProjectApiClass();

export const FoldersApi = new FoldersApiClass();

export const IndividualDeersApi = new SimpleApi<
  IndividualDeers.IndividualDeersFull,
  IndividualDeers.IndividualDeersCreate
>(individualDeersUrl);

export const DeerMeatSaleApi = new SimpleApi<
  DeerMeatSale.DeerMeatSaleFull,
  DeerMeatSale.DeerMeatSaleCreate
>(deerMeatSaleUrl);

export const AccountApi = new AccountApiClass();

export const MeasureApi = new SimpleApi<MeasureUnitBare, MeasureUnitCreate>(measureUrl);

export const MessageTemplateApi = new SimpleApi<
  MessageTemplate.MessageTemplateBare,
  MessageTemplate.MessageTemplateCreate
>(messageTemplateUrl);

export const ActivityApi = new SimpleApi<Catalogs.Activity, Catalogs.ActivityUpdate>(activityUrl);

export const SmsIntegrationsApi = new SimpleApi<
  SmsIntegrations.SmsIntegrationBare,
  SmsIntegrations.SmsIntegrationUpdate
>(smsIntegrationUrl);

export const FeedbackApi = new FeedbackApiClass();

export const ChatsApi = new ChatsApiClass();

export const IntegrationPersonApi = new IntegrationPersonApiClass();

export const NotificationApi = new NotificationApiClass();
export const AdministrationNewsApi = new AdministrationNewsApiClass();

export const PublicNewsApi = new PublicNewsApiClass();

export const TtpOrganizationsApi = new TtpOrganizationsApiClass();

export const TtpEventHistoryApi = new TtpEventHistoryClass();

export const TimetableExceptionsApi = new TimetableExceptionsApiClass();

export const MtsTypeApi = new MtsTypeApiClass();

export const NationApi = new SimpleApi<Nation, NationCreate>(nationUrl);

export const TtpApi = new TtpApiClass();

export const TtpIdentityDocumentsApi = new SimpleApi<
  TTPRegistries.PersonIdentityDocumentBare,
  TTPRegistries.PersonIdentityDocumentCreate
>(identityDocumentsUrl);

export const SubsurfaceUserApi = new SimpleApi<SubsurfaceUser, never, Omit<SubsurfaceUser, 'id'>>(
  subsurfaceUserUrl
);

export const StatisticsPublicApi = new StatisticsPublicApiClass();

export const PhysicalPersonApi = new PhysicalPersonApiClass();

export const PersonDeerApi = new PersonDeerApiClass();

export const FounderPersonApi = new FounderPersonApiClass();

export const CommuneApi = new CommuneApiClass();

export const UsefulLinksApi = new UsefulLinksApiClass();

export const HouseholdApi = new (class extends SimpleApi<TTPRegistries.HouseholdFull, never> {
  async delegate(id, info: ChangeHouseholdDelegate): Promise<StatusResponse> {
    const { data } = await http({
      ...TTP_PERSON_API.HOUSEHOLD.DELEGATE(id),
      data: info,
    });
    return data;
  }

  async updateBuildings(householdId: number, buildings: HouseholdBuilding[]) {
    const { data } = (await http({
      ...TTP_PERSON_API.HOUSEHOLD.UPDATE_BUILDINGS(householdId),
      data: buildings,
    })) as AxiosResponse<HouseholdShort>;

    return data;
  }
})(householdsUrl);

export const HouseholdRoleApi = new SimpleApi<TTPRegistries.HouseholdRole, never>(
  householdRolesUrl
);

export const PersonTtpExcerptApi = new PersonTtpExcerptApiClass();

export const OrganizationTtpExcerptApi = new OrganizationTtpExcerptApiClass();

export const MassMediaApi = new MassMediaApiClass();

export const SedDeloApi = new SedDeloApiClass();

export const StatisticsApi = new StatisticsApiClass();

export const EconomicalRelationshipsApi = new SimpleApi<
  TTPRegistries.EconomicalRelationship,
  New<TTPRegistries.EconomicalRelationship>
>(economicalRelationshipsUrl);

export const LicenseAreaApi = new SimpleApi<LicenseArea, never>(licenseAreUrl);

export const ThdBuildingApi = new SimpleApi<
  TTPRegistries.BuildingListElement,
  never,
  never,
  TTPRegistries.BuildingListElement
>(thdBuildingUrl);

/**
 * Класс CRUD для ЕГИССО.
 *
 * По определенной записи из реестра ТМЦ.
 */
export const EgissoApi = new SimpleApi<
  Egisso.EgissoFull,
  Egisso.EgissoCreate,
  Egisso.EgissoCreate,
  Egisso.EgissoBare
>(egissoUrl);

/**
 * Класс для получения списка отправленных запросов в ЕГИССО.
 *
 * По определенной записи из реестра ТМЦ.
 */
class EgissoRequestsApiClass extends SimpleApi<
  never,
  never,
  never,
  RegistryMaterialResource.EgissoRequest
> {
  /**
   * Ручная отмена ранее успешно отправленного назначения в ЕГИССО.
   * Возвращает обновлённый исходный запрос: причина/автор/XML записаны сразу,
   * `cancelledAt` проставится после успешного ответа от ЕГИССО.
   */
  public async cancel(id: number, payload: RegistryMaterialResource.EgissoRequestCancelPayload) {
    const endpoint = EGISSO_REQUESTS.CANCEL(id);
    const { data } = await http({
      ...endpoint,
      data: payload,
    });
    return data as RegistryMaterialResource.EgissoRequest;
  }
}

export const EgissoRequestsApi = new EgissoRequestsApiClass(egissoRequestsUrl);

export const DepzdravExportApi = new DepzdravExportApiClass(http);

export const DocumentsApi = new SimpleApi<
  DocumentFull,
  DocumentCreate,
  DocumentUpdate,
  DocumentBare
>(DOCUMENTS_URL);

export const CommissionApplicationsApi = new CommissionApplicationsApiClass();

export const CommissionMeetingsApi = new CommissionMeetingsApiClass();

export const CommissionParagraphsApi = new CommissionParagraphsApiClass();

export const CommissionDecisionsApi = new CommissionDecisionsApiClass();

export const ServiceLLMApi = new ServiceLLMApiClass();
